import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import styles from '@/styles/components/AppHeader.module.css';

export default function AppHeader() {
  const { t } = useTranslation();

  return (
    <header className={styles.header}>
      <LanguageSwitcher />
      <h1 className={styles.title}>{t('headerTitle')}</h1>
      <p className={styles.subtitle}>{t('headerSubtitle')}</p>
    </header>
  );
}